import { Component } from '@angular/core';


export class SkyCardActionsComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-card-actions',
  template: `<ng-content></ng-content>
`,
  styles: [`:host {
  display: block;
  border-top: 1px solid #e2e3e4;
  padding: 7px 0;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
